/* eslint-disable import/no-cycle */
import Http from '@/api/http';
import Storage from '@/storage';
/* eslint-enable import/no-cycle */

export default class Auth {
    static login(username, password) {
        return new Promise((resolve, reject) => {
            Http
                .postWithoutToken('/auth/token', {
                    username,
                    password,
                }).then((response) => {
                    Storage.setToken({
                        authorization: response.headers['access-token'],
                        lifetime: response.headers['token-lifetime'],
                    });
                    resolve(response);
                }).catch((error) => {
                    Storage.clearToken();
                    reject(error.response);
                });
        });
    }

    static renewToken() {
        return Http.get('/auth/token/renew');
    }
}
